import { call, put, takeEvery, takeLatest } from "redux-saga/effects"
import { showErrorMessages } from "helpers/helpers"
import { showMessage } from "components/Common/Toaster"
import { apiError } from "../actions"

// Login Redux States
import {
  CREATE_PRODUCT,
  GET_ALL_PRODUCTS,
  UPDATE_PRODUCT,
  DELETE_PRODUCT,
} from "./actionTypes"
import { changePreloader } from "../../store/layout/actions"
import {
  getAllProductsCall,
  createProductCall,
  updateProductCall,
  deleteProductCall,
} from "../../helpers/repository"
import { getAllProducts, getAllProductsResponseSuccess } from "./actions"
function* attemptGetAllProducts() {
  try {
    const response = yield call(getAllProductsCall)
    yield put(getAllProductsResponseSuccess(response.data.products))
  } catch (error) {
    showErrorMessages(error)
  }
}

function* attemptCreateProduct(action) {
  const { toggle } = action
  try {
    const response = yield call(createProductCall, action.payload)
    yield put(getAllProducts())
    showMessage("success", response.data.message)
    toggle()
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
    showErrorMessages(error)
  }
}

function* attemptUpdateProduct(action) {
  const { toggle } = action
  try {
    const response = yield call(updateProductCall, action.payload)
    yield put(getAllProducts())
    showMessage("success", response.data.message)
    toggle()
  } catch (error) {
    yield put(apiError(error?.response?.data?.errors))
    showErrorMessages(error)
  }
}

function* attemptDeleteProduct(action) {
  try {
    const response = yield call(deleteProductCall, action.payload)
    yield put(getAllProducts())
    showMessage("success", response.data.message)
  } catch (error) {
    showErrorMessages(error)
  }
}

function* ProductsSaga() {
  yield takeEvery(GET_ALL_PRODUCTS, attemptGetAllProducts)
  yield takeEvery(CREATE_PRODUCT, attemptCreateProduct)
  yield takeEvery(UPDATE_PRODUCT, attemptUpdateProduct)
  yield takeEvery(DELETE_PRODUCT, attemptDeleteProduct)
}

export default ProductsSaga
